import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { useStores } from 'stores/hooks/hooks';
import styled from 'styled-components';
import Grid from 'components/UI/Grid';
import Splitter from 'components/shared/Splitter';
import GrowerSystems from './GrowerSystems';
import SystemSensors from './SystemSensors';

const Container = styled.div`
  height: 100%;
  width: 100%;
  justify-content: flex-start;
`;

const Systems: FC = observer(() => {
  const {
    resellersStore: { selectedRowsSystems },
  } = useStores();

  //   {!selectedRowsPlots?.length && <Plots isLoading={isLoading} />}
  // {!!selectedRowsPlots?.length && (
  //   <Splitter>
  //     <div style={{ height: '100%' }}>
  //       <Plots isLoading={isLoading} />
  //     </div>
  //     <PlotSensors />
  //   </Splitter>
  // )}
  return (
    <Container>
      {!selectedRowsSystems?.length && <GrowerSystems />}
      {!!selectedRowsSystems?.length && (
        <Splitter>
          <div style={{ height: '100%' }}>
            <GrowerSystems />
          </div>
          <SystemSensors />
        </Splitter>
      )}
    </Container>
  );
});

export default Systems;
